import { Button } from '@cian/ui-kit';
import { IconFileEdit16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface ICommentsButtonNewProps {
  commented: boolean;
  onClick(): void;
}

export function CommentsButtonNew({ commented, onClick }: ICommentsButtonNewProps) {
  return (
    <div className={cx(styles['container'], commented && styles['container--opened'])}>
      <Button
        theme="stroke_secondary"
        beforeIcon={<IconFileEdit16 color="icon-secondary-default" />}
        onClick={onClick}
        size="XS"
        title="Комментарий"
      />
    </div>
  );
}
